import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { UserSettings, APIResponse, AppData, ObjectUtils } from 'fakturnia-shared';
import { SettingsApiService } from 'shared/services/api/settings.api.service';
import { SettingsService } from 'shared/services/settings.service';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  standalone: true,
  selector: 'default-payment-status',
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './default-payment-status.component.html',
  styleUrls: ['./default-payment-status.component.scss']
})
export class DefaultPaymentStatusComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = [];

  control = new FormControl<number>(0);

  statuses = AppData.PaymentStatuses;

  constructor(
    private _settingsApiService: SettingsApiService,
    private _settingsService: SettingsService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this._subscriptions.push(
      this._settingsService.getUserSettings().subscribe({
        next: (userSettings: UserSettings) => {
          const status = ObjectUtils.getNestedValue(userSettings, 'settings.autocomplete.defaultPaymentStatus');
          this.control.setValue(status === 1 ? 1 : 0, { emitEvent: false });
        }
      })
    );

    this._subscriptions.push(
      this.control.valueChanges.subscribe((value) => {
        this._settingsApiService.updateDefaultPaymentStatus(value!)
          .subscribe({
            next: (response: APIResponse) => {
              if (!response.success) {
                this._settingsService.refreshSettings();
                this._snackbarService.showSnackBar(response.message, 'error', 4000);
                return;
              }

              this._settingsService.refreshSettings();
              this._snackbarService.showSnackBar('Zapisano zmiany', 'success', 4000);
            }
          });
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
